module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fb356e819d8ab210a241ce81b9bac33c.png";